<template>
    <v-menu offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small class="mr-n2">
                <v-icon left>mdi-tune-variant</v-icon>
                <span>Filters</span>
            </v-btn>
        </template>
        <v-card flat class="pa-3" :min-width="displayedPoolTypes.length && displayedRoles.length ? 480 : 240">
            <v-row>
                <v-col v-if="displayedPoolTypes.length" cols="12" :md="displayedRoles.length ? 6 : 12" class="pool-filter-section">
                    <v-subheader class="text-uppercase">Resource pool type</v-subheader>
                    <v-sheet v-for="poolType in displayedPoolTypes" :key="poolType.value" rounded class="py-2 px-4 my-1">
                        <v-switch
                            inset
                            dense
                            hide-details
                            class="pa-0 ma-0"
                            :input-value="isSelected(poolType.value)"
                            @change="setTypeSelection(poolType.value, $event)">
                            <template v-slot:label>
                                <div class="d-flex align-center">
                                    <v-icon left small color="primary">{{ poolType.icon }}</v-icon>
                                    <span>{{ poolType.label }}</span>
                                </div>
                            </template>
                        </v-switch>
                    </v-sheet>
                </v-col>
                <v-col
                    v-if="displayedRoles.length"
                    cols="12"
                    :md="displayedPoolTypes.length ? 6 : 12"
                    class="pool-filter-section"
                    :class="{ 'pool-filter-section--divider': displayedPoolTypes.length }">
                    <v-subheader class="text-uppercase">User type</v-subheader>
                    <v-sheet v-for="role in displayedRoles" :key="role.value" rounded class="py-2 px-4 my-1">
                        <v-switch
                            inset
                            dense
                            hide-details
                            class="pa-0 ma-0"
                            :input-value="selectedRoles.includes(role.value)"
                            @change="setRoleSelection(role.value, $event)">
                            <template v-slot:label>
                                <div class="d-flex align-center">
                                    <v-icon left small color="primary">{{ role.icon }}</v-icon>
                                    <span>{{ role.label }}</span>
                                </div>
                            </template>
                        </v-switch>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-card>
    </v-menu>
</template>

<script>
import {
    RESOURCE_POOL_FILTER_TYPES,
    RESOURCE_POOL_FILTER_TYPE_OPTIONS,
    RESOURCE_POOL_ROLES,
    RESOURCE_POOL_ROLE_OPTIONS
} from '@/modules/user/components/resourcePoolMeta'

export default {
    name: 'PoolTypeFilterMenu',
    props: {
        value: {
            type: Array,
            default: null
        },
        availableTypes: {
            type: Array,
            default: () => RESOURCE_POOL_FILTER_TYPES.slice()
        },
        roles: {
            type: Array,
            default: () => RESOURCE_POOL_ROLES.slice()
        },
        availableRoles: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        displayedRoles() {
            return RESOURCE_POOL_ROLE_OPTIONS.filter(role => this.availableRoles.includes(role.value))
        },
        selectedRoles() {
            return this.roles.filter(role => this.availableRoles.includes(role))
        },
        availablePoolTypes() {
            return RESOURCE_POOL_FILTER_TYPES.filter(type => this.availableTypes.includes(type))
        },
        displayedPoolTypes() {
            return RESOURCE_POOL_FILTER_TYPE_OPTIONS.filter(type => this.availablePoolTypes.includes(type.value))
        },
        selectedPoolTypes() {
            if (!Array.isArray(this.value)) {
                return this.availablePoolTypes.slice()
            }

            const validPoolTypes = this.value.filter(type => this.availablePoolTypes.includes(type))
            return Array.from(new Set(validPoolTypes))
        }
    },
    methods: {
        setRoleSelection(role, selected) {
            const roles = this.roles.filter(value => value !== role)
            if (selected) roles.push(role)
            this.$emit('update:roles', roles)
        },
        isSelected(poolType) {
            return this.selectedPoolTypes.includes(poolType)
        },
        setTypeSelection(poolType, selected) {
            const nextSelectedPoolTypes = [...this.selectedPoolTypes]

            if (selected) {
                if (!nextSelectedPoolTypes.includes(poolType)) {
                    nextSelectedPoolTypes.push(poolType)
                }
            } else {
                const typeIndex = nextSelectedPoolTypes.indexOf(poolType)
                if (typeIndex !== -1) {
                    nextSelectedPoolTypes.splice(typeIndex, 1)
                }
            }

            this.$emit('input', nextSelectedPoolTypes)
        }
    }
}
</script>

<style scoped>
@media (min-width: 960px) {
    .pool-filter-section--divider {
        border-left: 1px solid rgba(0, 0, 0, 0.12);
    }
}
</style>
